import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: '首页', path: '/' },
  { label: '网红塌房', path: '/category/wanghong-tafang' },
  { label: '主播八卦', path: '/category/zhubo-bagua' },
  { label: '明星黑料', path: '/category/mingxing-heiliao' },
  { label: '独家爆料', path: '/category/dujia-baoliao' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const bgClass = isHome && !scrolled
    ? 'bg-transparent'
    : 'bg-background-50/95 backdrop-blur-md';

  const textClass = isHome && !scrolled
    ? 'text-white'
    : 'text-foreground-900';

  const logoClass = isHome && !scrolled
    ? 'text-white'
    : 'text-primary-500';

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${bgClass} ${scrolled ? 'shadow-sm' : ''}`}>
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className={`flex items-center gap-2 ${logoClass}`}>
            <div className="w-9 h-9 flex items-center justify-center">
              <i className="ri-fire-line text-2xl"></i>
            </div>
            <span className="text-lg font-bold whitespace-nowrap font-heading">91黑料吃瓜</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 hover:opacity-80 ${textClass} ${
                  location.pathname === item.path ? 'opacity-100 font-semibold' : 'opacity-90'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className="px-4 py-2 text-sm font-medium whitespace-nowrap rounded-md border transition-colors duration-200 cursor-pointer"
              style={{
                color: isHome && !scrolled ? 'white' : undefined,
                borderColor: isHome && !scrolled ? 'rgba(255,255,255,0.6)' : undefined,
              }}
            >
              关于我们
            </Link>
          </div>

          <button
            className={`md:hidden w-9 h-9 flex items-center justify-center ${textClass}`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-2">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm font-medium py-2 px-3 rounded-md whitespace-nowrap transition-colors ${
                  location.pathname === item.path
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="text-sm font-medium py-2 px-3 rounded-md whitespace-nowrap text-foreground-700 hover:bg-background-100"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}